import React from 'react';
import { formatActionType, formatTime, getActionIcon, parseDescription } from '../utils';

/**
 * HistoryItem - Renders a single history item (undo or redo action)
 */
const HistoryItem = ({
  action,
  index,
  isCurrent,
  isFuture,
  isGroup,
  isExpanded,
  onToggleGroup,
  onClick,
  undoStackLength,
}) => {
  const { title, detail } = parseDescription(action, formatActionType);
  const itemNumber = isFuture ? undoStackLength + index + 1 : index + 1;
  
  const itemClass = [
    'history-panel__item',
    isCurrent && 'history-panel__item--current',
    isFuture && 'history-panel__item--future',
    !isCurrent && !isFuture && 'history-panel__item--past',
    isGroup && 'history-panel__item--group',
  ].filter(Boolean).join(' ');

  const titleText = isCurrent 
    ? 'Current state' 
    : isFuture 
      ? 'Click to redo to this point' 
      : 'Click to go back to this point';

  return (
    <React.Fragment>
      <div 
        className={itemClass}
        onClick={onClick}
        title={titleText}
      >
        {isGroup && (
          <button 
            className={`history-panel__expand-btn ${isExpanded ? 'history-panel__expand-btn--expanded' : ''}`}
            onClick={(e) => { e.stopPropagation(); onToggleGroup(action.id); }}
            title={isExpanded ? 'Collapse' : 'Expand'}
          >
            ▶
          </button>
        )}
        <span className="history-panel__item-number">{itemNumber}</span>
        <span className="history-panel__item-icon">
          {getActionIcon(action.type)}
        </span>
        <div className="history-panel__item-content">
          <span className="history-panel__item-title">{title}</span>
          {detail && <span className="history-panel__item-detail">{detail}</span>}
        </div>
        <span className="history-panel__item-time">
          {formatTime(action.timestamp)}
        </span>
      </div>
      {/* Expanded sub-actions */}
      {isGroup && isExpanded && (
        <SubActionsList 
          subActions={action.subActions} 
          isFuture={isFuture}
        />
      )}
    </React.Fragment>
  );
};

/**
 * SubActionsList - Renders expanded sub-actions for a group
 */
const SubActionsList = ({ subActions, isFuture }) => {
  return (
    <div className={`history-panel__sub-actions ${isFuture ? 'history-panel__sub-actions--future' : ''}`}>
      {subActions.map((subAction, subIndex) => {
        const { title: subTitle, detail: subDetail } = parseDescription(subAction, formatActionType);
        return (
          <div 
            key={subAction.id || `sub-${subIndex}`}
            className="history-panel__sub-item"
          >
            <span className="history-panel__item-icon">
              {getActionIcon(subAction.type)}
            </span>
            <div className="history-panel__item-content">
              <span className="history-panel__item-title">{subTitle}</span>
              {subDetail && <span className="history-panel__item-detail">{subDetail}</span>}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default HistoryItem;
